import React, { PureComponent, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import TopbarSidebarButton from './TopbarSidebarButton';
import TopbarProfile from './TopbarProfile';

import config from '../../../config/config';
import configImages from '../../../config/configImages';
//session expiry modal
import SessionExpiryModal from '../../Cruds/CommonModals/SessionexpiryModal'

const Topbar  = (props) => {
  const propTypes = {
    changeMobileSidebarVisibility: PropTypes.func.isRequired,
    changeSidebarVisibility: PropTypes.func.isRequired,
  };

  const [settingsInfo, setSettingsInfo] = useState({});
  const [sessionExpiryModal, setsessionExpiryModal] = useState(false);
  const [viewState, setViewState] = useState(true)
  useEffect(() => {
    let sessionexpired = localStorage.getItem('sessionexpired')
    if (sessionexpired == "true") {      
      setsessionExpiryModal(true);
    }    
    return () => {      
    };
  }, []);
 
    const { changeMobileSidebarVisibility, changeSidebarVisibility } = props;
    return (
      <div className="topbar">
        <div className="topbar__wrapper">
          <div className="topbar__left">
            <TopbarSidebarButton
              changeMobileSidebarVisibility={changeMobileSidebarVisibility}
              changeSidebarVisibility={changeSidebarVisibility}
              setViewState={setViewState}
              viewState={viewState}
            />
            <Link className='topbarLogo' to="/homes" >
              {config.displayProjectName ?
                <img src={viewState ? configImages.topBarLogo : configImages.dosystemsWhiteLogo } className='topbarProjectLogo'></img> : config.appName}
            </Link>

          </div>
          <div className="topbar__right">
            <TopbarProfile />
          </div>
          {sessionExpiryModal ?
            <SessionExpiryModal
              SOpen={sessionExpiryModal}
            />
            : null}
        </div>
      </div>
    );
  }


export default Topbar;
